import React from "react";

import { ChatController } from "../../components/Chat/ChatController";

export const ChatPage: React.FC = () => {
  return <ChatController />;
};
